import React, { useState, useEffect} from "react";

import PoliticalFromContrib from "./PoliticalFormContrib"
import PoliticalFromDonate from "./PoliticalFormDonate"
import { isJwCole, isSteward } from "../../common/checkClient"

const PoliticalFormComp = (props) => {
    const jwCole = isJwCole();
    const steward = isSteward();

    const[contribType,setContribType] = useState(props.data.contribType);


    const [validation, setValidation] = useState({
        valid: true,
        contribType : true,
        description : true,
        contribDate : true,
        stateProv:true,
        contribAmount :true,
        currency :true,
        campaign :true,
        reqMsrb:true,
        politicalParty:true,
        contribIndividualOrPac:true,
        contribIndividualSoughtPosition:true,
        contribIndividualHoldOffice:true,
        contribIndividualActivePosition:true,

        contributorType:true,
        spouseLastName:true,
        spouseFirstName:true,
        contribTarget:true,
        politicalOrganizationType:true,
        politicalPartyVoteJurisdiction:true,
        politicalOrganizationName:true,
        politicalOrganizationJurisdiction:true,
        candidateName:true,
        officeSought:true,
        electionDate:true,
        officeSoughtJurisdiction:true,
        electionType:true,
        officeHeld:true,
        contribPaymentType:true,
        candidateContribAmount:true,
        otherPaymentMethod:true,
        otherContribMethod:true,
        contributePersonalFund:true,
        engagementInWorkingHours:true,
        engagementHours:true,
        usingOfficeResource:true,

        isIndividualPriorContrib:true,
        individualPriorContribDetail:true,
        individualPriorContribDate:true,
        individualPriorContribAmount:true,
        individualPriorContribCampaignOrganization:true,
        isCandidateAssociated:true,
        candidateAssociatedDesc:true,
        isCandidateClient:true,


      });

      const validate = () => {

        const jwColeContribution = (!jwCole || (jwCole && props.data.contribType === 'Contribution'));
        const jwColeDonation = (!jwCole || (jwCole && props.data.contribType === 'Donation'));
        const isContribution = props.data.contribType === 'Contribution';

        const fields = {
          contribType: props.data.contribType ? true : false,
          description: (props.data.description || (jwCole && (props.data.contribType === 'Contribution'))) ? true : false,
          contribDate: props.data.contribDate? true : false,
          stateProv: (props.data.contribType==='Donation'||jwCole || props.data.stateProv) ? true : false,
          politicalParty: (props.data.contribType==='Donation'|| jwCole || props.data.politicalParty) ? true : false,
          contribAmount: (props.data.contribAmount || (jwCole && props.data.contribType === 'Donation'))? true : false,
          currency: (props.data.currency || jwCole) ? true : false,
          campaign: (props.data.isCampaign=='N' || props.data.campaign) ? true : false,
          reqMsrb: props.data.reqMsrb ? true : false,
          contribIndividualOrPac: (jwCole || !isContribution || props.data.contribIndividualOrPac) ? true : false,
          contribIndividualSoughtPosition: !steward || props.data.contribIndividualOrPac != "IN" || props.data.contribIndividualSoughtPosition ? true : false,
          contribIndividualHoldOffice: !steward || props.data.contribIndividualOrPac != "IN" || props.data.contribIndividualHoldOffice ? true : false,
          contribIndividualActivePosition: !steward || props.data.contribIndividualHoldOffice != "Y" || props.data.contribIndividualActivePosition ? true : false,
          contributorType : props.data.contributorType || jwColeDonation ? true:false,
          //spouseLastName : props.data.spouseLastName || jwColeDonation ? true:false,
          //spouseFirstName : props.data.spouseFirstName || jwColeDonation? true:false,
          contribTarget : props.data.contribTarget || jwColeDonation ? true:false,
          politicalOrganizationType : props.data.politicalOrganizationType || !jwCole? true:false,
          politicalPartyVoteJurisdiction : props.data.politicalPartyVoteJurisdiction || jwColeDonation? true:false,
          politicalOrganizationName : props.data.politicalOrganizationName || !jwCole? true:false,
          politicalOrganizationJurisdiction : props.data.politicalOrganizationJurisdiction || jwColeDonation? true:false,
          candidateName : props.data.candidateName || jwColeDonation ? true:false,
          officeSought : props.data.officeSought || !jwCole? true:false,
          electionDate : props.data.electionDate || !jwCole? true:false,
          officeSoughtJurisdiction : props.data.officeSoughtJurisdiction || !jwCole? true:false,
          electionType : props.data.electionType || jwColeDonation? true:false,
          contribPaymentType : props.data.contribPaymentType || jwColeDonation ? true:false,
          candidateContribAmount : props.data.candidateContribAmount|| jwColeDonation ? true:false,
          contributePersonalFund:props.data.contributePersonalFund || jwColeContribution?true:false,
          engagementInWorkingHours:props.data.engagementInWorkingHours || jwColeContribution?true:false,
          engagementHours:props.data.engagementHours || props.data.engagementInWorkingHours!=="Yes" || jwColeContribution?true:false,
          usingOfficeResource:props.data.usingOfficeResource || jwColeContribution?true:false,

          isIndividualPriorContrib : props.data.isIndividualPriorContrib || jwColeDonation? true : false,
          individualPriorContribDetail :  props.data.isIndividualPriorContrib !== 'Yes' || props.data.individualPriorContribDetail || jwColeDonation? true : false,
          individualPriorContribDate : props.data.isIndividualPriorContrib !== 'Yes' || props.data.individualPriorContribDate || jwColeDonation? true : false,
          individualPriorContribAmount : props.data.isIndividualPriorContrib !== 'Yes' || props.data.individualPriorContribAmount || jwColeDonation? true : false,
          individualPriorContribCampaignOrganization : props.data.isIndividualPriorContrib !== 'Yes' || props.data.individualPriorContribCampaignOrganization || jwColeDonation? true : false,
          
          isCandidateAssociated : props.data.isCandidateAssociated || jwColeDonation? true : false,
          candidateAssociatedDesc : props.data.isCandidateAssociated !== 'Yes' || props.data.candidateAssociatedDesc || jwColeDonation? true : false,
          isCandidateClient : props.data.isCandidateClient || jwColeDonation? true : false,

        };

        const valid = Object.values(fields).every(Boolean);
        
        setValidation({...validation,...fields,valid});

        return valid;
      };

      const handleSaveClick = (e) => {
        if (!validate()) {
          return;
        }
        props.handleSaveClick(e);
      };

      const handleContribTypeChange = (contribType)=>{
        setContribType(contribType);
      }
      
      useEffect(()=>{
        props.handleChange({target:{name:"contribType",value:contribType}})
     },[contribType])


     useEffect(()=>{
      console.log(validation);
    },[validation])



    return (
        <div className="form">
            <div className="form-header">
                <div className="form-header-label">{props.editorMode === "UPDATE"?"Update":"Create a New"} Political Contribution & Fundraising/Solicitation/Volunteer Activity Request</div>
            </div>
            <div className="form-body">
              <div className="flex-vcenter">
                <label className="mr-3">Select Type of Request :</label>
                <div className="mt-4 mb-4">
                  <div className="switch">
                    <div className={`switch-item ${contribType==="Contribution" ? "selected" : "" }`} onClick={()=>handleContribTypeChange("Contribution")}>
                      <div className="switch-item-content">Political Contribution</div>
                    </div>
                    <div className={`switch-item ${contribType==="Donation" ? "selected" : "" }`} onClick={()=>handleContribTypeChange("Donation")}>
                      <div className="switch-item-content">Fundraising/Solicitation/Volunteer</div>
                    </div>                 
                  </div>
                </div>
              </div>

              {(contribType==="Contribution") &&
                <PoliticalFromContrib
                  editorMode={props.editorMode}
                  data={props.data}
                  validation={validation}
                  handleChange={props.handleChange}
                  handleDateChange = {props.handleDateChange}
                  
                  officials={props.officials}
                  officialAdd={props.officialAdd}
                  officialRemove={props.officialRemove}
                  officialChanged={props.officialChanged} 
                  
                  />}

              {(contribType==="Donation") &&
                <PoliticalFromDonate
                  editorMode={props.editorMode}
                  data={props.data}
                  validation={validation}
                  handleChange={props.handleChange}
                  handleDateChange = {props.handleDateChange}/>}

            </div>
            <div className="form-footer">
                    {validation.valid ? (
                <div className="form-status"></div>
                ) : (
                    <div className="form-status error">Enter Required Information</div>
                )}
                <div className="btn-group">
                <button id="btnCancel" type="button" className="btn btn-primary-outline" onClick={props.handleCancel}>Cancel</button>
                <button id="btnReview" type="button" className="btn btn-primary" onClick={handleSaveClick}>Save and Review</button>
                </div>
            </div>
        </div>
    )

}


export default PoliticalFormComp;